import { adminClient as apolloClient } from '@/store/apollo';

import UserApiTokensGql from '@/store/graphql/system/queries/UserApiTokens.gql';
import CreateUserApiTokenGql from '@/store/graphql/system/mutations/CreateUserApiToken.gql';
import DeleteUserApiTokenGql from '@/store/graphql/system/mutations/DeleteUserApiToken.gql';

/*
 * Personal API tokens: the acting super user's own credentials for tooling
 * (the Claude `ticket` skill). Always the own user, so no id travels.
 */
export default {
    fetchTokens: () =>
        apolloClient
            .query({
                query: UserApiTokensGql,
                fetchPolicy: 'network-only'
            })
            .then(({ data }) => data.UserApiTokens),

    createToken: (name) =>
        apolloClient
            .mutate({
                mutation: CreateUserApiTokenGql,
                variables: { name }
            })
            .then(({ data }) => data.CreateUserApiToken),

    deleteToken: (tokenId) =>
        apolloClient
            .mutate({
                mutation: DeleteUserApiTokenGql,
                variables: { token_id: parseInt(tokenId, 10) }
            })
            .then(({ data }) => data.DeleteUserApiToken)
};
